import React from 'react';
import Reflux from 'reflux';
import { Row, Col, Button } from 'bootstrap';
import { Map, OrderedMap } from 'immutable';
import UIRegions from 'shared/constants/UIRegions';

import AddTagMenu from 'shared/components/tag/addTagMenu';
import TagList from 'shared/components/tag/tagList';
import Dropdown from 'shared/components/menus/dropDown.jsx';
import Modal from 'shared/components/misc/modal.jsx';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import NewGlobalElementModalStore from 'shared/flux/stores/NewGlobalElementModalStore';
import NewGlobalElementModalActions from 'shared/flux/actions/NewGlobalElementModalActions';

/**
 * New Global Element Modal
 *
 */
export default React.createClass({
  displayName: 'NewGlobalElementModal',

  mixins: [Reflux.connect(NewGlobalElementModalStore, 'globalElement')],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const { globalElement } = this.state;

    const elementSetConfig = Map({
      noCaret: true,
      iconRight: 'angle-down',
      content:
        globalElement.getIn(['activeElementSet', 'title']) ||
        'Add to element set',
      items: globalElement
        .get('elementSets')
        .map((elementSet, elementSetId) => {
          return Map({
            type: 'link',
            content: elementSet.get('title'),
            onClick: () =>
              NewGlobalElementModalActions.changeActiveElementSet(elementSetId),
          });
        }),
    });

    const publishButtonDisabled =
      !globalElement.get('activeTags') ||
      globalElement.get('activeTags').size < 1 ||
      !globalElement.getIn(['activeElementSet', '_id'])
        ? true
        : false;

    return (
      <Modal
        headerClassName="modal-event"
        className="new-global-element-form-modal"
        name={UIRegions.NewGlobalElementModal}
        title={<b>Save as new global element</b>}
      >
        <Row className="new-global-element-form">
          <Col md={24} lg={24}>
            <Row>
              <p>
                You can save this element as a new global element and it will
                appear in your team's global element manager.
              </p>
            </Row>
            <Row className="new-global-element-form__field-wrapper">
              <Col md="24">
                <div className="new-global-element-form__element-categories">
                  <Dropdown
                    classes="generic-dropdown-menu ge-list-header-tab-dropdown"
                    config={elementSetConfig}
                  />
                </div>
                <div className="new-global-element-form__tags">
                  <AddTagMenu
                    displayNode={this._getTagDisplayNode()}
                    activeTagIds={globalElement.get('activeTags')}
                    tags={globalElement.get('tags')}
                    placement="bottom"
                    popoverId="addTagFilterMenu"
                    isFilter
                    caretIcon={<Icon name="angle-down" />}
                    onChange={(tagIds) =>
                      NewGlobalElementModalActions.changeActiveTag(tagIds)
                    }
                    displayLabel="Add to tag"
                  />
                  {this._getActiveTagList()}
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={24}>{this._getColumnAlert()}</Col>
            </Row>
            <Row>
              <Col md="24">
                <Button
                  className="new-global-element-form__publish-btn"
                  onClick={this._handlePublish}
                  disabled={publishButtonDisabled}
                >
                  Publish
                </Button>
                <Button
                  className="new-global-element-form__close-btn"
                  onClick={() => NewGlobalElementModalActions.clear()}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal>
    );
  },

  _getTagDisplayNode() {
    return (
      <span className="new-global-element-form__tags-display-node">
        <Button>
          <Icon name="tag" /> Tags <Icon name="angle-down" />
        </Button>
      </span>
    );
  },

  _getActiveTagList() {
    const { globalElement } = this.state;

    const tags = globalElement.get('tags');
    const activeTagIds = globalElement.get('activeTags');

    const activeTags = OrderedMap(
      activeTagIds
        .map((tagId) => [tagId, tags.get(tagId)])
        .filter((item) => item[1]),
    );

    return (
      <span className="new-global-element-form__tags-list">
        <TagList
          width={300}
          tags={activeTags}
          tagFilters={activeTags}
          popoverId="new-global-element-form-tags-popover"
          popoverTitle="Applied tags"
        />
      </span>
    );
  },

  _getColumnAlert() {
    const { globalElement } = this.state;

    if (!globalElement.get('columnDiscrepancy')) return null;

    return (
      <div className="new-global-element-form__column-alert">
        <div className="new-global-element-form__column-alert-icon">
          <Icon name="exclamation-triangle" />
        </div>
        <div className="new-global-element-form__column-alert-text">
          <b>Heads up!</b> The global element you're saving has a different
          column count than what's in your element manager which will result in
          a data mismatch.{' '}
          <a
            target="_blank"
            href="http://learn.shoflo.tv/global-element-basics/global-elements-managing-columns"
          >
            Learn More
          </a>
        </div>
      </div>
    );
  },

  _handlePublish() {
    const { teamId, eventId, showId } = this.context.router.state.params;
    NewGlobalElementModalActions.publish(teamId, eventId, showId);
  },
});
